import { useApolloClient } from '@apollo/client'
import { useEffect } from 'react'
import { MeQuery } from 'types/graphql'
import { getMeQuery } from './me'

export const useWatchMeQuery = (callbackFn: (me: MeQuery['me'] | undefined) => void) => {
  const client = useApolloClient()

  useEffect(() => {
    const subscription = client.watchQuery<MeQuery>({ query: getMeQuery, fetchPolicy: 'cache-only' }).subscribe(({ data }) => {
      callbackFn(data?.me)
    })

    return () => {
      if (subscription) {
        subscription.unsubscribe()
      }
    }
  }, [callbackFn, client])
}
